import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AntiRuidoPage = lazy(() => import('../pages/antiruido/page'));
const AltoPadraoPage = lazy(() => import('../pages/alto-padrao/page'));
const PortfolioPage = lazy(() => import('../pages/portfolio/page'));
const RegiaoAtendimentoPage = lazy(() => import('../pages/regiao-atendimento/page'));
const ContatoPage = lazy(() => import('../pages/contato/page'));
const ThankYouPage = lazy(() => import('../pages/obrigado/page'));
const PoliticaPrivacidadePage = lazy(() => import('../pages/politica-privacidade/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/linha-antiruido',
    element: <AntiRuidoPage />
  },
  {
    path: '/linha-alto-padrao',
    element: <AltoPadraoPage />
  },
  {
    path: '/portfolio',
    element: <PortfolioPage />
  },
  {
    path: '/regiao-atendimento',
    element: <RegiaoAtendimentoPage />
  },
  {
    path: '/contato',
    element: <ContatoPage />
  },
  {
    path: '/obrigado',
    element: <ThankYouPage />
  },
  {
    path: '/politica-privacidade',
    element: <PoliticaPrivacidadePage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
